import { Component } from 'react';
import { withRouter } from 'react-router';
import { IonAlert, IonButton, IonIcon } from '@ionic/react';
import { warningOutline } from 'ionicons/icons';
import { connect } from 'react-redux';
import { withTranslation } from '../../lib/translate';
import { SmallText } from '../common';
import './index.css';
import { forwardTo } from '../../lib/utils';

class ValidateButton extends Component {
  render() {
    const { __, profile, auth } = this.props;
    const isAuth = auth.loggedIn;
    const valid = profile.email_verified || false;
        const guest = profile.is_guest

    return (
      <>
        {isAuth && !valid && !guest ? (
          <>
            <div onClick={() => forwardTo('/verify-account')} className="validate-banner">
              <SmallText>
                <IonIcon
                  style={{
                    height: '20px',
                    width: '20px',
                    marginRight: '5px',
                  }}
                  icon={warningOutline}
                />
                {__('Email not verified.')}
              </SmallText>

              <IonButton
                
                fill="outline"
                className="validate-button"
                color="secondary"
              >
                {__('Verify')}
              </IonButton>
            </div>
          </>
        ) : null}
      </>
    );
  }
}

const stateToProps = (store) => {
  const { profile, auth } = store.profile;
  return {
    profile,
    auth,
  };
};

export default connect(stateToProps)(withRouter(withTranslation(ValidateButton)));
